/**
 * The org-dashboard tiles count only what a staff member may see (ISS-022), so a tile opens its
 * list narrowed to those same items. Absent `onlyKeys` means the whole list (an org admin, or any
 * other way into the dialog).
 */
export function restrictToKeys<T>(
    items: readonly T[],
    onlyKeys: readonly string[] | undefined,
    keyOf: (item: T) => string
): T[] {
    if (!onlyKeys) return [...items];
    const allowed = new Set(onlyKeys);
    return items.filter((item) => allowed.has(keyOf(item)));
}
